import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

const db = firebase.firestore();

type AdmConfigurationsState = {
    isLoading: boolean,
    error: Error | string | null;
    maintenanceStatus: boolean,
};

const initialState: AdmConfigurationsState = {
    isLoading: true,
    error: null,
    maintenanceStatus: false,
};

const slice = createSlice({
    name: 'admConfigurations',
    initialState,
    reducers: {
        startLoadingMaintenance(state) {
            state.isLoading = true;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        setMaintenanceStatusSuccess(state, action) {
            state.isLoading = false;
            state.maintenanceStatus = action.payload;
        },
    },
});

export const { setMaintenanceStatusSuccess } = slice.actions;

export default slice.reducer;

export function getMaintenanceStatus() {
    return async () => {
        dispatch(slice.actions.startLoadingMaintenance());
        try {
            const doc = await db.collection('configurations').doc('maintenance').get();
            if (doc.exists && doc.data()?.status) {
                dispatch(slice.actions.setMaintenanceStatusSuccess(doc.data()?.status));
            } else {
                dispatch(slice.actions.setMaintenanceStatusSuccess(false));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function updateMaintenanceStatus(status: boolean) {
    return async () => {
        dispatch(slice.actions.startLoadingMaintenance());
        try {
            await db.collection('configurations').doc('maintenance').set({
                type: 'maintenance',
                status: status
            }, { merge: true });
            dispatch(slice.actions.setMaintenanceStatusSuccess(status));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
